import { render, staticRenderFns } from "./StudentOfferInformationComp.vue?vue&type=template&id=e99bf456&scoped=true&"
import script from "./StudentOfferInformationComp.vue?vue&type=script&lang=ts&"
export * from "./StudentOfferInformationComp.vue?vue&type=script&lang=ts&"
import style0 from "./StudentOfferInformationComp.vue?vue&type=style&index=0&id=e99bf456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99bf456",
  null
  
)

export default component.exports